import { typedAction } from "../helpers";
import { LoadingState } from "../models/reduxModels";
import { DECREMENT_AMOUNT_LOADING, INCREMENT_AMOUNT_LOADING, SET_LOADING } from "./actionTypes";

const initialState: LoadingState = { isLoading: false, amountOfLoaders: 0 };

export const setLoading = (toggleReload: boolean) => {
    return typedAction(SET_LOADING, toggleReload);
};

export const incrementAmountOfLoaders = () => {
    return typedAction(INCREMENT_AMOUNT_LOADING);
};

export const decrementAmountOfLoaders = () => {
    return typedAction(DECREMENT_AMOUNT_LOADING);
};

type LoadingAction = ReturnType<typeof setLoading | typeof incrementAmountOfLoaders | typeof decrementAmountOfLoaders>;

export function loadingReducer(
    state = initialState,
    action: LoadingAction
): LoadingState {
    switch (action.type) {
        case SET_LOADING:
            return { ...state, isLoading: action.payload };
        case INCREMENT_AMOUNT_LOADING:
            return { ...state, amountOfLoaders: state.amountOfLoaders + 1 };
        case DECREMENT_AMOUNT_LOADING:
            return { ...state, amountOfLoaders: state.amountOfLoaders > 0 ? state.amountOfLoaders - 1 : 0 };
        default:
            return state;
    }
}